import { render, staticRenderFns } from "./RSelect.vue?vue&type=template&id=b0d3ef5e&scoped=true&"
import script from "./RSelect.vue?vue&type=script&lang=js&"
export * from "./RSelect.vue?vue&type=script&lang=js&"
import style0 from "./RSelect.vue?vue&type=style&index=0&id=b0d3ef5e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0d3ef5e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol})
